import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Android from "../../../../assets/images/android.svg";
import { setErrorInfo, setShowInfo } from '../../AxiosRtk/successMessage';

const DashboardSocialMedia = ({ getLangTranslation }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [isDisabled, setIsDisabled] = useState(true);

    const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
    const { appLanguageId } = useSelector(({ misc }) => misc);
    const { latestActivityData, kidList, selectedKidId, selectedDeviceData } = useSelector(({ dashboard }) => dashboard);
    
    const lang = AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find((item) => item?.id === appLanguageId);

    const isDevicesAvailable = kidList && selectedKidId
        ? kidList.find(kid => kid?.ID === selectedKidId)?.KidsDevices?.[0]?.Name
        : null;

    useEffect(() => {
        // Disable the button if no device is available
        if (!isDevicesAvailable) {
            setIsDisabled(true);
        } else {
            setIsDisabled(false);
        }
    }, [isDevicesAvailable]);
    function handleSocialMediaDataClick() {
        // if(latestActivityData?.socialApps?.length === 0) {
        //     dispatch(setErrorInfo({
        //         errorInfo: true,
        //         title: "DATA_NOT_AVAILABLE",
        //         defaultTitle: "Data not available"
        //     }))
        //     return;
        // }
        if (!selectedDeviceData) {
            dispatch(
                setShowInfo({
                    showInfo: true,
                    title: "PARENT_DASHBOARD_DEVICE_SETUP_NOT_FINISHED",
                    defaultTitle: "Please select device",
                })
            );
            return; // Stop further action if device is not selected
        }

        // Proceed to the /keyword-stats page if a device is selected
        if (!isDisabled) {
            history.push("/social-media-communication")
        }
    }

    function convertShortName(str) {
        if (str?.includes('and')) {
            const strArr = str?.split("and", 1);
            return strArr[0];
        }
        return str;
    }

    return (
        <div className="col-md-6 mb-6">
            <div className="card h-100">
                <div
                    className="card-header d-flex justify-content-between align-items-center c-pointer"
                    onClick={() => handleSocialMediaDataClick()}
                >
                    <h3 className="card-title mb-0">{getLangTranslation("ONBOARD_SOCIAL_MEDIA_TITLE", "Social media monitoring")}</h3>
                    <i className={`fa ${lang?.isRTL === 1 ? 'fa-angle-left' : 'fa-angle-right'}`} aria-hidden="true"></i>
                </div>
                <div className="card-body">
                    <div className="inline-list-wrap space-18">
                        {
                            latestActivityData?.socialApps?.map((item, index) => {
                                return (
                                    <div className="list-item flex-column pe-0" key={index}>
                                        <div className="icon-wrap mb-1 p-1 m-social">
                                            {item?.appCount > 0 && (
                                                <span className="badge rounded-pill">{item?.appCount}</span>
                                            )}
                                            <img
                                                src={item?.imageUrl}
                                                alt=''
                                                width={30}
                                                onError={(e) => {
                                                    e.target.error = null;
                                                    e.target.src = Android;
                                                }}
                                            />
                                        </div>
                                        <span className="mb-0 sm-title">{convertShortName(item?.appName)}</span>
                                    </div>
                                )
                            })
                        }
                    </div>
                    {
                        latestActivityData?.socialApps?.length === 0 && (
                            <div className='text-center mt-5'>
                                --- {getLangTranslation("NO_DATA_LOG", "No data found")} ---
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    )
}

export default DashboardSocialMedia